import type { ExpandedTransformedEntry, ExpandedGrade } from "@/lib/api/agtech/ticketsExpanded";

// ── Filter state used by the filter modal and page ─────────────────

export interface ApiFilterValues {
  scaleTicketId: string;
  shipDate: string;
  plcId: string;
  commodityId: string;
  customerIds: string[];
  shipFrom: string;
  shipTo: string;
}

export const DEFAULT_FILTER_VALUES: ApiFilterValues = {
  scaleTicketId: "",
  shipDate: "",
  plcId: "",
  commodityId: "",
  customerIds: [],
  shipFrom: "",
  shipTo: "",
};

export const DEFAULT_PAGE_SIZE = 100;

// ── Table row: one per settlement or advance ───────────────────────

export type RowInstanceType = "settlement" | "advance";

export interface TicketTableRow {
  _rowKey: string;

  // Grouping key
  scale_ticket_id: string;

  // Entry-level context
  quantity_entry_nbr: number;
  scale_ticket_gross_weight: string | null;
  scale_ticket_tare_weight: string | null;
  scale_quantity_lb: string | null;
  vendor_id: string;
  customer_id: string | null;
  customer_name: string | null;
  vehicle_id: string | null;
  plc_id: string;
  location_name: string | null;
  commodity_id: string;
  commodity_display_name: string | null;
  reference_code: string | null;
  ship_date: string | null;
  add_date: string | null;
  scale_uom_code: string | null;
  report_uom_code: string | null;

  // Settlement / advance identity
  instance_type: RowInstanceType;
  instance_nbr: number; // settlement_nbr or advance_nbr
  serial_nbr: number | null;
  uom_code: string | null;
  contract_nbr: number;
  vehicle_disposition_nbr: number;
  pricing_order: number;
  vp_quantity: string | null;
  vp_applied_quantity: string | null;
  deleted_flag: string | null;
  ship_from_id: string | null;
  ship_to_id: string | null;
  ship_from_name: string | null;
  ship_to_name: string | null;
  grades: ExpandedGrade[];

  // Keep the full entry for the detail modal
  _entry: ExpandedTransformedEntry;
}
